import { render, staticRenderFns } from "./MultiSignatureCustomization.vue?vue&type=template&id=4237a469"
import script from "./MultiSignatureCustomization.vue?vue&type=script&lang=js"
export * from "./MultiSignatureCustomization.vue?vue&type=script&lang=js"
import style0 from "./MultiSignatureCustomization.vue?vue&type=style&index=0&id=4237a469&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports